var moment = require('moment');
require('moment/locale/nb');

function useColonAsTimeSeparator(formats) {
  for (var key in formats) {
    formats[key] = formats[key].replace('H.', 'H:');
  }
}

moment.locale('nb');
useColonAsTimeSeparator(moment.localeData('nb')._longDateFormat);

moment.updateLocale('nb', {
  longDateFormat: {
    lll: 'dddd D. MMMM',
    llll: 'dddd D. MMMM YYYY'
  }
});

moment.updateLocale('en', {
  longDateFormat: {
    LT: 'HH:mm',
    lll: 'dddd, MMMM D',
    llll: 'dddd, MMMM D, YYYY'
  }
});

module.exports = moment;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/moment.js
 ** module id = 5
 ** module chunks = 1
 **/